<!-- 异步渲染 使用 requestAnimationFrame  -->
<template>
  <el-skeleton :loading="!render" animated>
    <template #template>
      <slot name="template">
        <el-skeleton-item variant="h3" style="width: 100%" />
      </slot>
    </template>
    <template #default>
      <slot name="default">
        <slot></slot>
      </slot>
    </template>
  </el-skeleton>
</template>
<script setup lang="ts">
  import { onMounted, onUnmounted } from 'vue';
  import type { LZD_RENDER_T } from './util';
  import { renderNext } from './util';
  import { ref } from 'vue';

  defineOptions({ name: 'LzdRender' });

  const render = ref(false);

  let renderInst: LZD_RENDER_T = null;
  onMounted(() => {
    renderInst = renderNext((_renderIndex) => {
      render.value = true;
    });
  });

  onUnmounted(() => {
    !render.value && renderInst?.destroy();
  });
</script>
